
import "./agent.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

import { db } from "../../services/firebaseConnection";
import { collection, doc, addDoc, getDoc, getDocs,  where, query,  orderBy } from "firebase/firestore";

import { useForm } from "react-hook-form";

/* redux */
import { useSelector, useDispatch } from "react-redux";
import { updateAgent } from "../../redux/agent/slice";

/* validação de campos */
import { masktelefone } from "../../services/masks/masks.ts";

/* navegação */
import { useNavigate } from "react-router-dom";

/* funções auxiliares */
import { registerLog, expiryDate, formError, showError, clearError, firstName } from "../../services/functions/functions.ts";

/* imagens */
import icon_success from "../../assets/sucesso.png";
import icon_whats from "../../assets/whats_icon.png";


export default function Agent() {

    const [error, setError] = useState("0");
    const [step, setStep] = useState(0);

    const [load, setLoad] = useState(true);
    const [loadAgent, setLoadAgent] = useState(false);

    const [plans, setPlans] = useState([]);
    const [selPlan, setSelPlan] = useState({id: 0, codigo_plano: "0", id_plano: "0"});

    const [tel, setTel] = useState("");

    const [isUpdatePlan, setIsUpdatePlan] = useState(false);

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    /* refs para tratamento de erros */
    const refAgente = useRef(null);
    const refLabelAgente = useRef(null);
    const refErrorAgente = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);


    const refErroPlano = useRef(null);

    const refPlanos = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

    const refCheckBox = useRef(null);

    const refErroAgente = useRef(null);

    const refLoad = useRef(null);
    const refButton = useRef(null);
    const refError = useRef(null);
    /* -- */

    const { handleSubmit, register, getValues, setValue, watch } = useForm();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [isPending, startTransition] = useTransition();

    const maskTelefone = watch("telefone");

    useEffect(() => { setValue("telefone", masktelefone(maskTelefone)) }, [maskTelefone]);

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        async function loadplans() {

            startTransition(async () => {

            try {

                let plans = [];

                const plansdb = collection(db, "plans");
                const plansquery = query(plansdb, where("data_termino_vigencia", "==", expiryDate()), orderBy("data_criacao", "asc"));
            
                const plansdocs = await getDocs(plansquery);

                plansdocs.forEach((doc) => {
                    plans.push({
                        id: doc.id,
                        codigo: doc.data().codigo,
                        ramo: doc.data().ramo,
                        atendimento: doc.data().atendimento,
                        valor: doc.data().valor,
                    })
                })

                setPlans([...plans]);

                //verifica qual o plano selecionado
                if(agent.status > 1 && agent.status < 5) {
                    for(let i = 0; i < plans.length; i++) {               
                        if(plans[i].codigo === agent.plano) {
                            setSelPlan({id: i + 1, codigo_plano: agent.plano, id_plano: agent.id});
                        }
                    }
                }

                if(agent.status === 4) {
                    load_agent();
                }

            }
            catch(erro) {
                console.log(erro);
            }

            });

        }

        loadplans();

    }, [])


    async function load_agent() {

        const docRef = doc(db, "agents", agent.id);
        const docSnap = await getDoc(docRef); 

        setValue("agente", docSnap.data().nome);
        setValue("telefone", docSnap.data().telefone);

        setTel(docSnap.data().telefone);
 
    }



    async function create_agent(e) {

        e.preventDefault();
        formError(refError, "", false);

        let nm = getValues("agente");
        if(nm.length < 2) {
            showError(refAgente, refLabelAgente, refErrorAgente, "O nome do agente deve ter de 3 a 12 caracteres", setError, "agente");
            return;
        }

        if(selPlan.id === 0) {
            setError("plano");
            refErroPlano.current.innerHTML = "Selecione um plano para seu agente";
            refErroPlano.current.style.height = "1.5rem";
            return;
        }
        
        let uid = user.id;
        let dt_atual = new Date();

        try {

            setLoadAgent(true);
            refButton.current.innerHTML = "AGUARDE ...";

            const docagent = await addDoc(collection(db, "agents"), 
            { 
                id_client: uid,
                id_plan: selPlan.id_plano,
                data_criacao: dt_atual,
                data_inicio_vigencia: dt_atual,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
                nome: nm,
                telefone: null,
                plano: selPlan.codigo_plano,
                data_inicio_ativacao: null,
                data_termino_ativacao: null,
                status: 1,
                status_motivo: null,
            })

            sessionStorage.setItem('agente_id', JSON.stringify(docagent.id)); 
            sessionStorage.setItem('agente', JSON.stringify(nm));
            sessionStorage.setItem('plano', JSON.stringify(selPlan.codigo_plano));
            sessionStorage.setItem('status', JSON.stringify(1));

            dispatch(updateAgent({
                id: docagent.id,
                nome: nm,
                plano: selPlan.codigo_plano,
                status: 1,
            }))

            registerLog(uid, "/create_agent/id=" + docagent.id);

            setLoadAgent(false);

            setStep(1);
            window.scrollTo(0, 0);

        } catch(erro) {
            
            formError(refError, JSON.stringify(erro), true);
            refButton.current.innerHTML = "CRIAR AGENTE";
            setLoadAgent(false);
            
        }

    }



    async function update_agent(data) {


        
    }



    async function desactive_plan(data) {
    
        try {

            setIsUpdatePlan(true);

            
            
        }
        catch(erro) {
            console.log(erro);
        }
        finally {
            setIsUpdatePlan(false);
        }

    }


    async function desactive_account(data) {

        alert(refCheckBox.current.checked);
        
    }



    function agent_back() {
        setStep(0);
    }



    function panel() {
        navigate("/panel");
    }

  

    function seleciona_plano(iid, pid, dic) {

        let itt = plans.length;

        for(let i = 0; i < itt; i++) { refPlanos[i].current.style.backgroundColor = ""; }

        switch(iid) {
        case 1: 
            if(itt === 1) {
                refPlanos[iid - 1].current.style.borderRadius = "10px 10px 10px 10px";
            } else {
                refPlanos[iid - 1].current.style.borderRadius = "10px 10px 0px 0px";
            }
            break;

        case itt:
            refPlanos[iid - 1].current.style.borderRadius = "0px 0px 10px 10px";
            break;

        default:
            refPlanos[iid - 1].current.style.borderRadius = "0px 0px 0px 0px";
        }
        
        refPlanos[iid - 1].current.style.backgroundColor = "yellow";
        setSelPlan({id: iid, codigo_plano: pid, id_plano: dic});

        refErroPlano.current.innerHTML = "";
        refErroPlano.current.style.height = "0";
        setError(0);
        
    }
    

    
    function agents_contents() {

        switch(selPlan.codigo_plano.substring(0, 3)) {
            case "CMD":
                navigate("/medical");
            case "EST":
                navigate("/aesthetic");
        }

    }



    return(
        
        <div className="context">

            <Header access={1}></Header>

            <div className="content">

            { step === 0 && (
            <>

                { (agent.status === 0 || agent.status > 4) && (
                <>
                <div className="ft_topico">Crie seu agente</div>
                <div className="ft_descricao">Essas são as configurações básicas para a criação do seu agente, onde você lhe dará um nome e escolherá um plano que mais se adequa as suas necessidades.</div>
                <div className="space"></div>

                    { isPending ? (
                    <>
                    <div className="border_form agent_border_form">
                        <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="border_form agent_border_form">
                    <form className="form" onSubmit={handleSubmit(create_agent)}>
                        <span className="title_form">Nome do agente</span>
                        <span className="subtitle_form">Defina um nome para seu agente, ele será usado para interagir com os seus clientes.</span>

                        <span ref={refErrorAgente} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelAgente}>
                        <input type="text" placeholder="&nbsp;" maxLength={12} {...register("agente")} ref={(el) => {refAgente.current = el; register("agente").ref(el);}} onClick={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} onChange={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)}></input>
                        <span className="label">Nome do agente</span>
                        <span className="focus-bg"></span>
                        </label>

                        <span className="space_form"></span>
                        <span className="title_form">Escolha um plano</span>
                        <span className="subtitle_form">Clique no plano para selecionar, cada agente poderá ter apenas um plano associado. Selecione o plano que melhor atende as suas necessidades.</span>

                        <span ref={refErroPlano} className="error_form"></span>
                        <div className="agent_plano_campos">
                            <span className="agent_plano_campos1">código</span>
                            <span className="agent_plano_campos2">segmento</span>
                            <span className="agent_plano_campos3">atendimento</span>
                            <span className="agent_plano_campos4">mensalidade</span>
                        </div>
                        <div className="agent_plano_frame">

                        { plans.map((item, index) => (
                        <>  
                            <div ref={refPlanos[index]} className="agent_plano_item" onClick={() => agent.status !== 2 && agent.status !== 3 && seleciona_plano(index + 1, item.codigo, item.id )} style={{backgroundColor: selPlan.id === index + 1 ? "yellow" : "", cursor: agent.status === 2 || agent.status === 3 ? "" : "pointer", borderRadius: selPlan.id === 1 ? plans.length === 1 ? "10px 10px 10px 10px" : "10px 10px 0px 0px" : selPlan.id === plans.length ? "0px 0px 10px 10px" : "0px 0px 0px 0px"}}>
                                <span className="agent_plano_item1">{ item.codigo }</span>
                                <span className="agent_plano_item2">{ item.ramo }</span>
                                <span className="agent_plano_item3"><img className="agent_image_whats" src={icon_whats}></img></span>
                                <span className="agent_plano_item4">grátis por 7 dias</span>
                            </div>
                        
                            { index + 1 < plans.length && (
                                <>
                                <div className="agent_plano_line">
                                    <div className="agent_plano_lineitem"></div>
                                </div>  
                                </>
                            )}
                        </>
                        ))}
                        </div>
                        <span className="agent_aviso_mensalidade">* a mensalidade só é cobrada caso você opte em assinar o serviço</span>
                        
                        <span className="space_form"></span>
                        <span ref={refError} className="error_form"></span>
                        <span className="space_form"></span>

                        <button type="button" name="bt1a" ref={refButton} className={loadAgent ? "button_disabled_form" : "button_form"} onClick={create_agent} disabled={loadAgent}>CRIAR AGENTE</button>
                    </form>
                    </div>
                    </>
                    )}
                </>
                )}                    

                { agent.status === 1 && (
                <>
                
                </>
                )}

                { agent.status === 2 && (
                <>
                
                </>
                )}

                { agent.status === 4 && (
                <>
                <div className="ft_topico">Altere seu agente</div>
                <div className="ft_descricao">Aqui você pode alterar seu agente e suas respectivas configurações, bem como, desátivá-lo.</div>
                <div className="space"></div>

                    { isPending ? (
                    <>
                    <div className="border_form agent_border_form">
                        <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="border_form agent_border_form">
                        <form className="form" onSubmit={handleSubmit(update_agent)}>
                            <span className="title_form">Alterar o nome do agente</span>

                            <span ref={refErrorAgente} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelAgente}>
                            <input type="text" placeholder="&nbsp;" maxLength={12} {...register("agente")} ref={(el) => {refAgente.current = el; register("agente").ref(el);}} onClick={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} onChange={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)}></input>
                            <span className="label">Nome do agente</span>
                            <span className="focus-bg"></span>
                            </label>

                            <span className="space_form"></span>
                            <span ref={refErroAgente} className="error_form"></span>
                            <span className="space_form"></span>

                            <button type="submit" name="bt1a" ref={refButton} className={loadAgent ? "button_disabled_form" : "button_form"} disabled={loadAgent}>ALTERAR NOME</button>

                        </form>
                    </div>

                    <span className="space"></span>

                    <div className="border_form agent_border_form">
                        <form className="form" onSubmit={handleSubmit(update_agent)}>
                            <span className="title_form">Alterar a linha do agente</span>
                            <span className="subtitle_form">Para realizar essa operação serão necessários alguns pré requisitos.</span>

                            <span ref={refErrorAgente} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelAgente}>
                            <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone")} ref={(el) => {refTelefone.current = el; register("telefone").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError);}}}></input>
                            <span className="label">Telefone (DDD + Telefone)</span>
                            <span className="focus-bg"></span>
                            </label>

                            <span className="space_form"></span>
                            <span className="space_form"></span>

                            <button type="submit" name="bt1b" ref={refButton} className={loadAgent ? "button_disabled_form" : "button_form"} disabled={loadAgent}>ALTERAR NÚMERO</button>

                        </form>
                    </div>

                    <span className="space"></span>

                    <div className="border_form agent_border_form">
                        <form className="form">
                            <span className="title_form">Outras alterações</span>
                            <span className="subtitle_form">Desative ou altere as configurações do seu agente.</span>
                            <span className="agent_aviso_plano">Para alterar o plano, é necessário desativar o agente atual e criar um novo agente.</span>
                            <span className="space_form"></span>
                            <div className="agent_box_buttons">
                                <div className="agent_box_buttons_1a"><button type="button" name="bt1c" className="button2_form" onClick={ (e) => {setStep(2); window.scrollTo(0, 0);} }>DESATIVAR</button></div>
                                <div className="agent_box_buttons_1b"></div>
                                <div className="agent_box_buttons_1c"><button type="button" name="bt1d" className="button_form">ALTERAR CONFIGURAÇÕES</button></div>
                            </div>
                        </form>
                    </div>
                    </>
                    )}
                </>
                )}

            </>
            )}
            
            
            { step === 1 && (
            <>
            <div className="ft_topico">Agente criado</div>
            <div className="ft_descricao">Parabéns, seu agente <span className="agent_success_01">{agent.nome}</span> está criado e associado a um plano.<br />Com base nesse plano, você irá configurá-lo de acordo com suas informações.</div>
            <div className="space"></div>
            <img className="agent_image" src={icon_success}></img>
            <div className="space"></div>
            <span className="agent_success_02">Caso querira configurar seu agente agora, clique no botão abaixo</span>
            <span className="agent_success_03">*você pode configurá-lo em outro momento, se preferir</span>
            <div className="space"></div>
            <div className="agent_box_button">
                <button type="button" name="btF" className="button_form" onClick={agents_contents}>CONFIGURAR AGENTE</button>
            </div>
            
            </>
            )}


            { step === 2 && (
            <>
            <div className="ft_topico">Altere seu agente</div>
            <div className="ft_descricao">Aqui você pode alterar seu agente e suas respectivas configurações, bem como, desátivá-lo.</div>
            <div className="space"></div>

            <div className="border_form agent_border_form">
                <form className="form" onSubmit={handleSubmit(desactive_plan)}>
                    <span className="title_form">Desativar agente - plano</span>
                    <span className="subtitle_form">Desativar o agente para mudar o plano:</span>
                    <span className="agent_descricao">Para mudar o plano de um agente é necessário desativá-lo, pois cada plano é adqueado a um respectivo ramo de atividade e, com isso, temos particularidades pertencentes a cada atividade, inviabilizando a migração de dados entre planos.</span>
                    <span className="agent_descricao">Nessa modalidade, o número da sua linha permanecerá com você e ficará associada a seu novo agente. Entretanto, é importante ressaltar que as informações de configurações e atendimentos não podem ser transferidas e seu novo agente.</span>
                    <span className="agent_descricao">Ao desativar o plano do seu agente, sua assinatura continuará vigente, incidindo a cobrança mensal normalmente, por isso, é recomendável que você crie um novo agente o mais breve possível.</span>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <button type="submit" name="bt3a" className="button2_form" disabled={isUpdatePlan}>DESATIVAR</button>
                </form>
            </div>

            <div className="space"></div>

            <div className="border_form agent_border_form">
                <form className="form" onSubmit={handleSubmit(desactive_account)}>
                    <span className="title_form">Desativar agente - conta</span>
                    <span className="subtitle_form">Desativar o agente para encerrar sua conta:</span>
                    <span className="agent_descricao">Desativando seu agente nessa modalidade, sua assinatura conosco será encerrada, seu agente irá parar de funcionar em até vinte e quatro horas e todo histórico será perdido.</span>
                    <span className="agent_descricao">É imprescindível também informar que o número da linha de seu agente será disponibilizado a outro cliente e não será mais possível reaver esse mesmo número.</span>
                    <span className="agent_descricao">Todas as suas futuras mensalidades serão canceladas a partir desse momento, conforme nossos termos de uso.</span>
                    <span className="space_form"></span>
                    <div className="agent_terms">
                        <input type="checkbox" className="checkbox_default" ref={refCheckBox}></input>
                        <span className="agent_terms_text">Estou ciente conforme os termos de uso.</span>
                    </div>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <button type="submit" name="bt3b" className="button2_form">DESATIVAR</button>                    
                </form>
            </div>

            <span className="space"></span>
            <div className="agent_button_back">
                <button type="button" name="bt3c" className="button_form" onClick={ (e) => {setStep(0); window.scrollTo(0, 0);} }>VOLTAR</button>
            </div>
            </>
            )}


{/* 
                <div className="ft_topico">{ agent.status === 1 ? "Crie seu agente" : agent.status === 2 ? "Veja seu agente" : "Altere seu agente" }</div>
                <div className="ft_descricao">{  "Essas são as configurações básicas para a criação do seu agente, onde você lhe dará um nome e escolherá um plano que mais se adequa as suas necessidades."titleTextStatusAgent(agent.status).texto }</div>
                <div className="space"></div>

                <div className="agent">

                    <form className="form" onSubmit={handleSubmit(create_agent)}>

                    { step === 0 && (
                    <>
                    { agent.status === 2 || agent.status === 3 ? (
                    <>
                    <span className="agent_titulo">Nome do Agente</span>
                    <span className="agent_descricao">Nome que você definiu para seu agente.</span>                                        
                    </>) : agent.status === 4 ? (
                    <>
                    <span className="agent_titulo">1. Redefina o nome do seu agente</span>
                    <span className="agent_descricao">Você pode redefinir um nome para seu agente de acordo com suas necessidades.</span>                                        
                    </>) : (
                    <>
                    <span className="agent_titulo">1. Defina um nome para seu agente</span>
                    <span className="agent_descricao">O nome do agente que você definir, será aquele usado para interagir com os seus clientes.</span>                    
                    </>
                    )}   

                    <span ref={refErrorAgente} className="error_form"></span>
                    <label for="inp" className="inp" ref={refLabelAgente}>
                    <input type="text" placeholder="&nbsp;" maxLength={12} {...register("agente")} ref={(el) => {refAgente.current = el; register("agente").ref(el);}} onClick={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} onChange={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} disabled={ agent.status === 2 ? true : false }></input>
                    <span className="label">Nome do agente</span>
                    <span className="focus-bg"></span>
                    </label>

                    <span className="space_form"></span>

                    { agent.status === 2 || agent.status === 3 ? (
                    <>
                    <span className="agent_titulo">Plano</span>
                    <span className="agent_descricao">Você definiu o plano selecionado abaixo para seu agente.</span>
                    </>) : agent.status === 4 ? (
                    <>
                    <span className="agent_titulo">2. Altere o telefone</span>
                    <span className="agent_descricao">Você poderá atribuir um outro número de linha telefônica a seu agente (sujeito a análise).</span>
                    
                    <span id="errorAgent_telefone" className="error_form"></span>
                    <label for="inp" className="inp">
                    <input type="text" id="telefone" placeholder="&nbsp;" maxLength={15} {...register("telefone")}></input>
                    <span className="label">Novo Telefone</span>
                    <span className="focus-bg"></span>
                    </label>                    
                    </>) : (
                    <>
                    <span className="agent_titulo">2. Escolha um plano</span>
                    <span className="agent_descricao">Clique no plano para selecionar, cada agente poderá ter apenas um plano associado. Selecione o plano que melhor atende as suas necessidades.</span>
                    </>
                    )}

                    { agent.status === 4 && (
                    <>
                    <span className="space_form"></span>
                    <span className="agent_titulo">3. Altere o plano</span>
                    <span className="agent_descricao">Você poderá alterar o plano do seu agente, entretanto, cada plano possui características próprias, e isso faz com que seja necessário configurar o agente novamente.</span>
                    </>
                    )}

                    <span ref={refErroPlano} className="error_form"></span>
                    <div className="agent_plano_campos">
                        <span className="agent_plano_campos1">código</span>
                        <span className="agent_plano_campos2">segmento</span>
                        <span className="agent_plano_campos3">atendimento</span>
                        <span className="agent_plano_campos4">mensalidade</span>
                    </div>

                    <div className="agent_plano_frame">

                    { plans.map((item, index) => (
                    <>  
                        <div ref={refPlanos[index]} className="agent_plano_item" onClick={() => agent.status !== 2 && agent.status !== 3 && seleciona_plano(index + 1, item.codigo, item.id )} style={{backgroundColor: selPlan.id === index + 1 ? "yellow" : "", cursor: agent.status === 2 || agent.status === 3 ? "" : "pointer", borderRadius: selPlan.id === 1 ? plans.length === 1 ? "10px 10px 10px 10px" : "10px 10px 0px 0px" : selPlan.id === plans.length ? "0px 0px 10px 10px" : "0px 0px 0px 0px"}}>
                            <span className="agent_plano_item1">{ item.codigo }</span>
                            <span className="agent_plano_item2">{ item.ramo }</span>
                            <span className="agent_plano_item3"><img className="agent_image_whats" src={icon_whats}></img></span>
                            <span className="agent_plano_item4">{ "R$ " + item.valor.toFixed(2) }</span>
                        </div>
                    
                        { index + 1 < plans.length && (
                            <>
                            <div className="agent_plano_line">
                                <div className="agent_plano_lineitem"></div>
                            </div>  
                            </>
                        )}
                    </>
                    ))}
                    </div>

                    { agent.status === 2 || agent.status === 3 ? (
                    <>
                    <span className="space_form"></span>
                    <span className="agent_titulo">Status do agente</span>
                    <span className="agent_status">Pendente de Ativação</span>
                    <span className="agent_descricao">Seu agente foi criado e configurado, agora basta esperar a ativação. Em muito breve lhe enviaremos um email com o número de telefone que seu agente irá atender. Você tem sete dias de gratuidade para realizar todos os testes que julgar necessário.</span>
                    </>
                    ) : (<></>)}

                    
                    <span className="agent_aviso_mensalidade">* a mensalidade só é cobrada caso você opte em assinar o serviço</span>
                    <span className="space_form"></span>

                    { agent.status === 2 || agent.status === 3 ? (
                    <>
                    <div className="agent_box_buttons">
                        <div className="agent_box_buttons_1a"><button type="button" name="bt1a" className="button2_form" onClick={panel}>VOLTAR</button></div>
                        <div className="agent_box_buttons_1b"></div>
                        <div className="agent_box_buttons_1c"><button type="button" name="bt1b" className="button_form" onClick={direciona_configuracao}>{ textButtonAgent(agent.status) }</button></div>
                    </div>
                    </>) : (
                    <>
                    <span className="space_form"></span>
                    <button type="button" name="bt1a" className="button_form" onClick={ agent_step1 }>{ textButtonAgent(agent.status) }</button>
                    </>)
                    }

                    { agent.status === 4 && (
                    <>
                    <span className="space_form"></span>
                    <div className="agent_buttons">
                        <div className="agent_buttons_back"><button type="button" name="bt1b" className="button2_form">DESATIVAR</button></div>
                        <div className="agent_buttons_space"></div>
                        <div className="agent_buttons_confirm"><button type="submit" name="bt1c" className="button_form">ALTERAR CONFIGURAÇÕES</button></div>
                    </div>
                    </>
                    )}
         
                    </>
                    )}



                    { step === 1 && (
                    <>
                    <span className="agent_titulo">Confirmação</span>
                    <span className="agent_descricao">Confirme se os dados do seu agente estão corretos:</span>
                    
                        { agent.status === 0 && (
                        <>
                        <span className="agent_confirm_title">Nome do Agente:</span>
                        <span className="agent_confirm_item">{getValues("agente")}</span>
                        <span className="space_form"></span>
                        <span className="agent_confirm_title">Plano Selecionado:</span>
                        <span className="agent_confirm_item">{ plans[selPlan.id - 1].ramo }</span>
                        <span className="agent_confirm_item">{ plans[selPlan.id - 1].atendimento.replace("W", "WhatsApp Business") }</span>
                        <span className="agent_confirm_item">{ "Assinatura mensal de R$ " + plans[selPlan.id - 1].valor.toFixed(2) + " (caso opte)" }</span>
                        </>
                        )}

                        { agent.status === 4 && (
                        <>
                        <span className="agent_confirm_title">Nome Atual:&nbsp;<span className="agent_confirm_item">{agent.nome}</span></span>
                        <span className="agent_confirm_title">Novo Nome:&nbsp;<span className="agent_confirm_item">{getValues("agente")}</span></span>

                            { tel !== getValues("telefone") && (
                            <>
                            <span className="space_form"></span>
                            <span className="agent_line"></span>
                            <span className="space_form"></span>
                            <span>Identificamos que você quer trocar a linha telefônica do seu agente</span>
                            <span>A troca da linha é um processo manual onde teremos que analisar as seguintes situações:</span>
                            <span>- A linha não pode ser de uso pessoal ou profissional, devendo ser alocada exclusivamente para o agente, pois não há como separar atendimento do agente de conversas pessoais ou profissionais;</span>
                            <span>- A linha precisa estar desvinculada do WhatsApp e WhatsApp Business para que possamos alocar em nossa conta;</span>
                            <span>- É possível que precisemos interagir com você para vincular a nova linha a nossa conta;</span>
                            <span className="space_form"></span>
                            <span className="agent_confirm_title">Telefone Atual:&nbsp;<span className="agent_confirm_item">{tel}</span></span>
                            <span className="agent_confirm_title">Telefone Novo:&nbsp;<span className="agent_confirm_item">{getValues("telefone")}</span></span>
                            </>
                            )}

                            { agent.plano !== selPlan.codigo_plano && (
                            <>
                            <span className="space_form"></span>
                            <span className="agent_line"></span>
                            <span className="space_form"></span>
                            <span>Identificamos que você quer trocar o Plano</span>
                            <span>A troca de planos poderá ocorrer, entretanto, é necessário que você configure novamente seu agente para o novo plano, pois cada plano possui características particulares onde não é possível realizar a migração sem que o agente seja novamente configurado.</span>
                            <span className="space_form"></span>
                            <span className="agent_confirm_title">Plano Atual:&nbsp;<span className="agent_confirm_item">{agent.plano}</span></span>
                            <span className="agent_confirm_title">Plano Novo:&nbsp;<span className="agent_confirm_item">{selPlan.codigo_plano}</span></span>
                            </>
                            )}

                        </>
                        )}
                    
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <div className="agent_buttons">
                        <div className="agent_buttons_back"><button type="button" name="bt2" className="button2_form" onClick={ agent_back }>VOLTAR</button></div>
                        <div className="agent_buttons_space"></div>
                        <div className="agent_buttons_confirm"><button type="submit" name="bt3" className="button_form">CONFIRMAR</button></div>
                    </div>

                    </>
                    )}

                    { step === 2 && (
                    <>
                    <span className="agent_titulo">Agente Criado</span>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <img className="agent_image" src={icon_success}></img>
                    <span className="space_form"></span>
                    <span className="agent_success_01">Parabéns!</span>
                    <span className="agent_success_01">Seu agente foi criado com sucesso!</span>
                    <span className="space_form"></span>
                    <span className="agent_success_02">Para que ele funcione, você precisa configurá-lo.</span>
                    <span className="agent_success_02">A configuração do agente é a etapa mais importante, pois é nela que você fará toda a personalização das informações e a forma e regras de prestação de serviço que ele executará.</span>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <span className="agent_success_03">Você não precisa configurar seu agente nesse momento, poderá fazer mais tarde.</span>
                    <span className="agent_success_03">Basta ir no Painel do Cliente e clicar em "CONFIGURAR AGENTE".</span>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <button type="button" name="bt3" className="button_form" onClick={direciona_configuracao}>CONFIGURAR AGENTE</button>
                    </>
                    )}

                    </form>

                </div> */}

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>

        </div>

    )
}